// JuvidermFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface internalLinking {
    heading: string;
    items: [] | any;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    internalLinking: internalLinking
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const juvidermFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Juvederm Filler Treatment | #1 dermal filler in Dubai",
            "description": "Get Juvederm filler collection at Elite Body Home. Revitalize your look with Juvederm dermal fillers for key areas like lips, cheeks, under-eyes, and jawline.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/juvederm-fillers/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Juvederm Filler Treatment | #1 dermal filler in Dubai",
                "description": "Get Juvederm filler collection at Elite Body Home. Revitalize your look with Juvederm dermal fillers for key areas like lips, cheeks, under-eyes, and jawline.",
                "url": "https://elitebodyhome.com/juvederm-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:37:05+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Juvederm Filler",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Juvederm Filler Treatment | #1 dermal filler in Dubai",
                "description": "Get Juvederm filler collection at Elite Body Home. Revitalize your look with Juvederm dermal fillers for key areas like lips, cheeks, under-eyes, and jawline.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Juvederm Fillers"],
        "hero": {
            "title": "Juvederm Fillers in Dubai",
            "subtitle": "Enhance Your innate beauty with Juvederm fillers.",
            "description": "Juvederm Filler, a popular surgery that precisely shapes and rejuvenates your features, can help you enhance your natural beauty. The hyaluronic acid compound in Juvederm produces results that seem natural and last, whether your goal is to smooth out tiny wrinkles, restore volume, or achieve a fuller, more defined appearance. Millions of people across the world trust this innovative filler because it is tailored to your unique facial contours and ensures a youthful, refreshed appearance. Experience the confidence that comes from having beautifully balanced, rejuvenated skin. At Elite Body Home, our skilled professionals are here to support you as you pursue timeless beauty."
        },
        "howItWorks": {
            "title": "Juvederm Fillers: What Are They?",
            "description": "Skin naturally contains hyaluronic acid, the basis for the FDA-approved Juvederm family of dermal fillers. Fillers are injected into specific facial areas to improve volume, smooth out wrinkles, and make the face look younger. This therapy is commonly used to treat nasolabial folds, deep wrinkles, fine lines, and decreased volume in places such as the lips and cheeks."
        },
        "procedureSteps": {
            "heading": "Procedure For Juvederm Fillers Using Revolax Fillers",
            "para": "Juvederm filler is a minimally invasive procedure that involves injecting a hyaluronic acid-based gel into the skin to smooth wrinkles, enhance volume, and enhance facial features.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "a consultation with a trained professional to identify the facial features that would benefit from the procedure.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Numbing",
                    "desc": "To guarantee comfort throughout the injection procedure, a topical anesthetic is used.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "Injections",
                    "desc": "A tiny needle is used to inject the filler into specific locations.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Forming",
                    "desc": "In order to shape the filler and guarantee uniform distribution, the practitioner may gently massage the area after injection.",
                    "icon": "fa-solid fa-hand-sparkles"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages",
            "subheading": "",
            "para": "Juvederm fillers provide a number of cosmetic advantages by enhancing facial symmetry and reducing common signs of aging. A non-invasive treatment with a quick recovery time, Juvederm offers a variety of aesthetic improvements. Because hyaluronic acid from Juvederm is biocompatible, it enhances the body's natural processes.",
            "items": [
                {
                    "title": "Decreased",
                    "desc": "minimizes fine lines and wrinkles, particularly those near the lips, eyes, and forehead.",
                    "icon": "fa-solid fa-face-grin-wink"
                },
                {
                    "title": "Volume Restoration",
                    "desc": "restores lost volume in areas such as the lips, cheeks, and beneath the eyes.",
                    "icon": "fa-solid fa-weight-hanging"
                },
                {
                    "title": "Lip enhancement",
                    "desc": "makes the lips appear younger by adding volume and definition.",
                    "icon": "fa-solid fa-lips"
                },
                {
                    "title": "Texture of Smooth Skin",
                    "desc": "improves the skin's hydration and smoothness, making it appear more radiant.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Non-Surgical",
                    "desc": "There is no need for incisions, surgery, or a protracted recovery time.",
                    "icon": "fa-solid fa-hospital-user"
                },
                {
                    "title": "Adaptable",
                    "desc": "can be changed to suit a person's preferred style and facial structure.",
                    "icon": "fa-solid fa-sliders"
                }
            ]
        },
        "eligibility": {
            "heading": "Qualifications",
            "subheading": "",
            "para": "Juvederm is an option for people who wish to enhance facial features or reduce the appearance of wrinkles without having surgery. Most healthy people may be eligible for Juvederm, but it's important to consider a few factors before beginning therapy. For you, Juvederm might be a good choice if you:",
            "items": [
                {
                    "title": "Age",
                    "desc": "They are older than eighteen.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "Wrinkle Reduction",
                    "desc": "Desire to minimize fine lines and wrinkles on the face.",
                    "icon": "fa-solid fa-face-meh"
                },
                {
                    "title": "Volume Enhancement",
                    "desc": "Desire larger cheeks or lips.",
                    "icon": "fa-solid fa-face-grin-beam"
                },
                {
                    "title": "Health Status",
                    "desc": "- Are not nursing or pregnant.\nDo not suffer from serious allergies or active skin infections.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Expectations",
                    "desc": "Have reasonable hopes for the result.\nIn general, they are healthy.",
                    "icon": "fa-solid fa-lightbulb"
                }
            ]
        },
        "internalLinking": {
            "heading": "Explore Our Dermal Fillers for Complete Facial Enhancement",
            "items": [{ "name": "Chin Fillers", "link": "/services/chin-fillers-dubai" },
            { "name": "Nose Fillers", "link": "/services/nose-fillers-dubai" },
            { "name": "Lip Fillers", "link": "/services/lip-fillers-dubai" },
            { "name": "Jawline Fillers", "link": "/services/jawline-fillers-dubai" },
            { "name": "Teosyal Fillers", "link": "/services/teosyal-fillers" },
            { "name": "Under Eye Fillers", "link": "/services/under-eye-fillers-dubai" }
            ]
        },
        "preparationTips": {
            "heading": "How to Get Ready for a Juvederm Filler Procedure",
            "subheading": "",
            "para": "With the right preparation, you can increase the success of your Juvederm filler operation and prevent complications. Preparing for a Juvederm treatment includes making sure your skin is healthy and free of inflammation.",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "For at least a week prior to treatment, refrain from taking aspirin, ibuprofen, or other blood-thinning medications to minimize bruising.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Keep Yourself Hydrated",
                    "desc": "Drink plenty of water before your session as it will increase the efficacy of your treatment.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Limit drinking",
                    "desc": "Avoid drinking for at least 24 hours prior to treatment in order to reduce the risk of bruising or swelling.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Quit Smoking",
                    "desc": "Because smoking can impede recovery, refrain from smoking for a few days prior to and after the therapy.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Share Allergies",
                    "desc": "Inform your physician of any sensitivities or allergies you may have, particularly to hyaluronic acid or lidocaine.",
                    "icon": "fa-solid fa-allergies"
                }
            ]
        },
        "results": {
            "heading": "Findings",
            "subheading": "",
            "para": "Juvederm fillers improve facial characteristics and give the illusion of younger skin with instant and long-lasting results.",
            "items": [
                {
                    "title": "Instant Smoothing & Volume",
                    "desc": "Areas like the cheeks and lips regain volume, while wrinkles and folds are smoothed out.",
                    "icon": "fa-solid fa-face-grin-stars"
                },
                {
                    "title": "Enhancement That Looks Natural",
                    "desc": "Juvederm produces effects that are subtle and natural-looking by blending in perfectly with the skin.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Very little downtime",
                    "desc": "While some swelling or bruising may occur, most patients are able to resume their regular activities right away.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "Prolonged Impacts",
                    "desc": "Results might last anywhere from six to twenty-four months, depending on the product and treatment region.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Got questions about Juvederm? Here are some answers to help you feel informed and confident.",
            "items": [
                {
                    "question": "What are jawline fillers made of?",
                    "answer": "Most jawline fillers are made of hyaluronic acid, a naturally occurring substance in the body. This helps in achieving defined yet natural-looking enhancements."
                },
                {
                    "question": "How long do jawline fillers last?",
                    "answer": "Jawline fillers typically last between 12 to 18 months, depending on the product used and individual metabolism. Periodic touch-ups can help maintain results."
                },
                {
                    "question": "Is the procedure painful?",
                    "answer": "Most patients experience minimal discomfort. A topical numbing cream is usually applied to make the procedure as comfortable as possible."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common side effects include temporary swelling, bruising, or redness at the injection site. These effects usually resolve within a few days"
                },
                {
                    "question": "Can jawline fillers be reversed?",
                    "answer": "Yes, if hyaluronic acid-based fillers are used, the results can be reversed using an enzyme called hyaluronidase. This makes the treatment flexible and low-risk."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "",
                "title": "Nasolabial folds",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sgtfjk-1.jpg"
            },
            {
                "ar": "",
                "title": "Lips",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sgtfjk-2.jpg"
            },
            {
                "ar": "",
                "title": "Cheeks",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sgtfjk-3.jpg"
            }
        ],
        "treatmentAreas2": [
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/15.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Dermal-Filler-2.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/31.webp"
            ]
        },
        "product": {
            "id": 109,
            "title": "Juvederm Filler Treatment Package",
            "price": 499,
            "description": "Refresh your facial features with Juvederm fillers—ideal for enhancing lips, under-eyes, cheeks, and jawline with natural, long-lasting results and minimal downtime."
        },
    },
   "ar": {
    "url": "",
    "meta": {
        "title": "فيلر جوفيديرم في دبي | أفضل حشوات الجلد في دبي",
        "description": "احصل على مجموعة فيلر جوفيديرم في Elite Body Home. جدد مظهرك بحشوات جوفيديرم لمناطق مثل الشفاه، الخدود، تحت العينين، وخط الفك.",
        "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
        "canonical": "https://elitebodyhome.com/services/juvederm-fillers/",
        "og": {
            "locale": "ar_AR",
            "type": "article",
            "title": "فيلر جوفيديرم في دبي | أفضل حشوات الجلد في دبي",
            "description": "احصل على مجموعة فيلر جوفيديرم في Elite Body Home. جدد مظهرك بحشوات جوفيديرم لمناطق مثل الشفاه، الخدود، تحت العينين، وخط الفك.",
            "url": "https://elitebodyhome.com/services/juvederm-fillers/",
            "site_name": "elitebodyhome.com",
            "updated_time": "2024-12-30T10:37:05+00:00",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg",
            "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg",
            "image_width": 1254,
            "image_height": 700,
            "image_alt": "فيلر جوفيديرم",
            "image_type": "image/jpeg"
        },
        "twitter": {
            "card": "summary_large_image",
            "title": "فيلر جوفيديرم في دبي | أفضل حشوات الجلد في دبي",
            "description": "احصل على مجموعة فيلر جوفيديرم في Elite Body Home. جدد مظهرك بحشوات جوفيديرم لمناطق مثل الشفاه، الخدود، تحت العينين، وخط الفك.",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-64.jpg"
        }
    },
    "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر جوفيديرم"],
    "hero": {
        "title": "فيلر جوفيديرم في دبي",
        "subtitle": "عزّز جمالك الطبيعي مع فيلر جوفيديرم",
        "description": "فيلر جوفيديرم هو إجراء شائع يساعد في تجديد ملامحك وتحديدها بدقة. يحتوي فيلر جوفيديرم على حمض الهيالورونيك الذي يعطي نتائج تبدو طبيعية وتستمر لفترة طويلة، سواء كان هدفك هو تنعيم التجاعيد الصغيرة، أو استعادة الحجم المفقود، أو الحصول على مظهر أكثر امتلاءً وتحديدًا. يثق ملايين الأشخاص حول العالم بهذا الفيلر المبتكر لأنه مصمم ليتناسب مع ملامح وجهك الفريدة ويضمن مظهرًا شابًا ومنتعشًا. اختبر الثقة التي تأتي مع بشرة متجددة ومتوازنة الجمال. نحن هنا في ايليت بادي هوم لدعمك في سعيك نحو الجمال الدائم."
    },
    "howItWorks": {
        "title": "ما هو فيلر جوفيديرم؟",
        "description": "تحتوي البشرة بشكل طبيعي على حمض الهيالورونيك، وهو المكون الأساسي لعائلة فيلر جوفيديرم المعتمدة من إدارة الغذاء والدواء (FDA). يُحقن الفيلر في مناطق محددة من الوجه لتحسين الحجم، وتنعيم التجاعيد، ومنح الوجه مظهرًا أكثر شبابًا. يُستخدم هذا العلاج بشكل شائع لعلاج الطيات الأنفية الشفوية، والتجاعيد العميقة، والخطوط الدقيقة، وفقدان الحجم في مناطق مثل الشفاه والخدين."
    },
    "procedureSteps": {
        "heading": "خطوات إجراء فيلر جوفيديرم",
        "para": "يُعد فيلر جوفيديرم إجراء غير جراحي، يتضمن حقن چل يحتوي على حمض الهيالورونيك في الجلد لتنعيم التجاعيد، وزيادة الحجم، وتحسين ملامح الوجه.",
        "steps": [
            {
                "title": "الاستشارة",
                "desc": "تتم جلسة استشارية مع طبيب متخصص لتحديد ملامح الوجه التي يمكنها الاستفادة من الإجراء.",
                "icon": "fa-solid fa-comment-medical"
            },
            {
                "title": "التخدير",
                "desc": "يُستخدم مخدر موضعي، لضمان الراحة طوال فترة الحقن.",
                "icon": "fa-solid fa-spray-can"
            },
            {
                "title": "الحقن",
                "desc": "تُستخدم إبرة رفيعة لحقن الفيلر في الأماكن المحددة.",
                "icon": "fa-solid fa-syringe"
            },
            {
                "title": "التشكيل",
                "desc": "قد يقوم الطبيب بتدليك المنطقة برفق لتوزيع الفيلر بشكل متساوي.",
                "icon": "fa-solid fa-hand-sparkles"
            }
        ]
    },
    "benefits": {
        "heading": "الفوائد",
        "subheading": "",
        "para": "توفر حقن جوفيديرم العديد من المزايا التجميلية من خلال تحقيق تناسق الوجه وتقليل علامات التقدم في العمر الشائعة. يعد جوفيديرم علاجًا غير جراحي بجانب تطلبه لوقت تعافي قصير، ويقدم مجموعة واسعة من التحسينات الجمالية. نظرًا لأن حمض الهيالورونيك المكون لفيلر جوفيديرم يتوافق حيويًا مع الجسم، فإنه يعزز العمليات الطبيعية به.",
        "items": [
            {
                "title": "تقليل الخطوط الدقيقة والتجاعيد",
                "desc": "يقلل بشكل ملحوظ من الخطوط الدقيقة والتجاعيد، خصوصًا في المناطق المحيطة بالفم والعينين والجبهة.",
                "icon": "fa-solid fa-face-grin-wink"
            },
            {
                "title": "استعادة الحجم المفقود",
                "desc": "يعيد ملء الحجم المفقود في مناطق مثل الشفاه والخدين وأسفل العين.",
                "icon": "fa-solid fa-weight-hanging"
            },
            {
                "title": "تحسين الشفاه",
                "desc": "يجعل الشفاه تبدو أكثر شبابًا من خلال إضافة حجم إليها وتحديدها.",
                "icon": "fa-solid fa-lips"
            },
            {
                "title": "تحسين ملمس البشرة",
                "desc": "يحسن ترطيب البشرة ونعومتها، مما يجعلها تبدو أكثر إشراقًا.",
                "icon": "fa-solid fa-spa"
            },
            {
                "title": "إجراء غير جراحي",
                "desc": "لا يتطلب إجراء شقوق أو جراحة،أو فترة تعافي طويلة.",
                "icon": "fa-solid fa-hospital-user"
            },
            {
                "title": "إجراء قابل للتعديل حسب الحاجة",
                "desc": "يمكن تعديله ليناسب أسلوب الشخص المفضل وبنية وجهه.",
                "icon": "fa-solid fa-sliders"
            }
        ]
    },
    "eligibility": {
        "heading": "المرشح المناسب لفيلر جوفيديرم",
        "subheading": "",
        "para": "يعد فيلر جوفيديرم خيارًا مثاليًا للأشخاص الذين يرغبون في تحسين ملامح الوجه أو تقليل ظهور التجاعيد دون اللجوء إلى جراحة. يلائم الإجراء معظم الاشخاص الأصحاء، ولكن يجب أخذ بعض العوامل في الاعتبار قبل بدء العلاج.",
        "items": [
            {
                "title": "العمر",
                "desc": "إذا كان عمرك أكثر من ثمانية عشر عامًا.",
                "icon": "fa-solid fa-user-check"
            },
            {
                "title": "تقليل التجاعيد",
                "desc": "إذا كنت ترغب في تقليل الخطوط الدقيقة والتجاعيد في الوجه.",
                "icon": "fa-solid fa-face-meh"
            },
            {
                "title": "زيادة الحجم",
                "desc": "إذا كنت ترغب في تكبير الخدين أو الشفاه.",
                "icon": "fa-solid fa-face-grin-beam"
            },
            {
                "title": "الحالة الصحية",
                "desc": "إذا كنتِ غير حامل أو مُرضعة.\nإذا كنت لا تعاني من حساسية شديدة أو عدوى جلدية نشطة.",
                "icon": "fa-solid fa-heart-pulse"
            },
            {
                "title": "التوقعات",
                "desc": "إذا كان لديك توقعات واقعية عن النتائج.\nإذا كنت بصحة جيدة بشكل عام.",
                "icon": "fa-solid fa-lightbulb"
            }
        ]
    },
    "internalLinking": {
        "heading": "اكتشف مجموعتنا من فيلر البشرة لتعزيز جمال الوجه بالكامل",
        "items": [
            { "name": "فيلر الذقن", "link": "/services/chin-fillers-dubai" },
            { "name": "فيلر الأنف", "link": "/services/nose-fillers-dubai" },
            { "name": "فيلر الشفاه", "link": "/services/lip-fillers-dubai" },
            { "name": "فيلر خط الفك", "link": "/services/jawline-fillers-dubai" },
            { "name": "فيلر تيوسيال", "link": "/services/teosyal-fillers" },
            { "name": "فيلر تحت العين", "link": "/services/under-eye-fillers-dubai" }
        ]
    },
    "preparationTips": {
        "heading": "الاستعداد لجلسة فيلر جوفيديرم",
        "subheading": "",
        "para": "يمكنك تعزيز نتائج فيلر جوفيديرم وتقليل احتمالية حدوث أي مضاعفات من خلال الاستعداد الصحيح. يتضمن التحضير لهذا العلاج التأكد من أن بشرتك في حالة صحية وخالية من أي التهابات.",
        "items": [
            {
                "title": "تجنب مُميعات الدم",
                "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو أي أدوية مميعة للدم لمدة أسبوع على الأقل قبل الجلسة لتقليل خطر الكدمات.",
                "icon": "fa-solid fa-pills"
            },
            {
                "title": "حافظ على ترطيب الجسم",
                "desc": "اشرب كميات كافية من الماء قبل الجلسة، حيث يساعد الترطيب الجيد في تعزيز فعالية العلاج.",
                "icon": "fa-solid fa-glass-water"
            },
            {
                "title": "تقليل شرب الكحول",
                "desc": "تجنب شرب الكحول لمدة 24 ساعة قبل الجلسة لتقليل احتمالية التورم أو الكدمات.",
                "icon": "fa-solid fa-wine-glass-empty"
            },
            {
                "title": "الإقلاع عن التدخين",
                "desc": "يمكن أن يبطئ التدخين عملية التعافي، يُنصح بالتوقف عن التدخين قبل الجلسة وبعدها بعدة أيام.",
                "icon": "fa-solid fa-smoking-ban"
            },
            {
                "title": "إبلاغ الطبيب بالحساسية",
                "desc": "أخبر الطبيب بأي حساسية تعاني منها، خصوصًا إذا كانت تجاه حمض الهيالورونيك أو الليدوكايين.",
                "icon": "fa-solid fa-allergies"
            }
        ]
    },
    "results": {
        "heading": "النتائج",
        "subheading": "",
        "para": "يُساعد فيلر جوفيديرم في تعزيز ملامح الوجه ومنح البشرة مظهراً أكثر شباباً بفضل نتائجه الفورية وطويلة الأمد.",
        "items": [
            {
                "title": "امتلاء فوري وتنعيم التجاعيد",
                "desc": "يستعيد الوجه حجمه في مناطق مثل الخدود والشفاه، ويُنعم التجاعيد والخطوط.",
                "icon": "fa-solid fa-face-grin-stars"
            },
            {
                "title": "تحسين طبيعي لملامح الوجه",
                "desc": "يمتزج فيلر جوفيديرم بسلاسة مع البشرة، مما يمنحها نتائج طبيعية وغير مبالغ فيها.",
                "icon": "fa-solid fa-leaf"
            },
            {
                "title": "وقت تعافي قصير جدًا",
                "desc": "قد تظهر بعض الكدمات أو التورم، إلا أن معظم المرضى يمكنهم العودة إلى أنشطتهم اليومية مباشرة بعد الجلسة.",
                "icon": "fa-solid fa-stopwatch"
            },
            {
                "title": "نتائج تدوم طويلاً",
                "desc": "تدوم النتائج من 6 إلى 24 شهراً، حسب نوع الفيلر والمنطقة المُعالجة.",
                "icon": "fa-solid fa-calendar-check"
            }
        ]
    },
    "aftercareTips": {
        "heading": "",
        "subheading": "",
        "para": "",
        "items": [
            {
                "title": "",
                "desc": "",
                "icon": "fa-solid fa-water"
            }
        ]
    },
    "faqData": {
        "heading": "الأسئلة الشائعة",
        "subheading": "هل لديك أسئلة حول فيلر جوفيديرم؟ إليك بعض الإجابات لمساعدتك على الشعور بالثقة والمعرفة.",
        "items": [
            {
                "question": "ما هو المكون الرئيسي لفيلر جوفيديرم؟",
                "answer": "المكون الرئيسي هو حمض الهيالورونيك، وهي مادة طبيعية موجودة في الجسم تساعد في تحقيق نتائج طبيعية المظهر."
            },
            {
                "question": "كم تدوم نتائج فيلر جوفيديرم؟",
                "answer": "عادةً ما تدوم النتائج من 12 إلى 18 شهرًا، اعتمادًا على نوع المنتج المستخدم وطبيعة الجسم. يمكن الحفاظ على النتائج بجلسات متابعة."
            },
            {
                "question": "هل الإجراء مؤلم؟",
                "answer": "يشعر معظم المرضى بانزعاج بسيط. عادةً ما يتم تطبيق كريم مخدر موضعي لجعل الإجراء مريحًا قدر الإمكان."
            },
            {
                "question": "هل هناك أي آثار جانبية؟",
                "answer": "تشمل الآثار الجانبية الشائعة تورمًا مؤقتًا أو كدمات أو احمرارًا في موقع الحقن. تزول هذه الآثار عادةً خلال بضعة أيام."
            },
            {
                "question": "هل يمكن عكس نتائج فيلر جوفيديرم؟",
                "answer": "نعم، إذا تم استخدام فيلر جوفيديرم القائم على حمض الهيالورونيك، يمكن عكس النتائج باستخدام إنزيم الهيالورونيداز. وهذا يجعل العلاج مرنًا ومنخفض المخاطر."
            }
        ]
    },
    "treatmentAreas1": [
        {
            "ar": "",
            "title": "الطيات الأنفية الشفوية",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sgtfjk-1.jpg"
        },
        {
            "ar": "",
            "title": "الشفاه",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sgtfjk-2.jpg"
        },
        {
            "ar": "",
            "title": "الخدود",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sgtfjk-3.jpg"
        }
    ],
    "treatmentAreas2": []
}
};
